﻿import { mapGetters, mapState } from 'vuex';

export default {
    name: 'dynamic-icon',
    template: '<svg :role="prole" :title="ptitle" :class="[pcondition ? pclass : pclass + \' \' + pconditionclass ]" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="icon" /></svg>',
    props: ['icon', 'prole', 'ptitle', 'pclass', 'pcondition', 'pconditionclass', 'width', 'height'],
}